<template>
  <vx-card>
    <form-knowledge-detail :id="id"></form-knowledge-detail>

    <div class="flex flex-row justify-end gap-4">
      <b-button @click="goBack" variant="outline-secondary">Voltar</b-button>
    </div>

  </vx-card>
</template>

<script>

import {
  BButton,
  VBTooltip,
} from 'bootstrap-vue'
import KnowledgeService from '@/services/api/KnowledgeService'
import FormKnowledgeDetail from './FormKnowledgeDetail.vue'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BButton,
    FormKnowledgeDetail,
  },
  props: {
    id: {
      type: Number,
      default: null
    }
  },
  data: () => ({
    service: null,
  }),
  methods: {
    goBack() {
      this.$router.push({
        name: 'knowledge-item-consult'
      })
    }
  },
  computed: {

  },
  beforeMount() {
    this.service = KnowledgeService.build(this.$vs)
  },
}
</script>


<style lang="scss" scoped>
  ::v-deep .vs-popup {
    width: 800px !important;
  }
</style>
